const toggleFaqQuestion = (event) => {
    const accordion_item = event.target.closest('.accordion-item');
    const accordion_item_content = accordion_item.querySelector('.accordion-item__content');
    if (accordion_item.classList.contains('active')) {
        accordion_item_content.style.height = "0";
        accordion_item.classList.remove('active');
    }
    else {
        accordion_item_content.style.height = accordion_item_content.scrollHeight + "px";
        accordion_item.classList.add('active');
    }
}

export function addAccordionFunctionality () {
    const faq_question_titles = document.getElementsByClassName('accordion-item__title');

    for (let i = 0; i < faq_question_titles.length; i++) {
        faq_question_titles[i].addEventListener('click', toggleFaqQuestion);
    }
}